/**
 * @file Route: login
 *
 * This file is compiled as a standalone entrypoint and it is included by
 * default in its blade template.
 * This is a "standard" route, it does not have a structure to follow, you are
 * sure the DOM is always ready and the JS will only be executed in this route.
 */

import "./index.scss";
import "layouts/main";
import { AuthLogin } from "components/Form/Auth/Login";

console.log("Route login/index.js mounted.");

AuthLogin();
